export default __webpack_public_path__ + "static/media/status-in.95b73111.svg";